/**
 * @function fetchApi
 *
 * The main API function. All API requests go through this function. Depending
 * on the value of REACT_APP_USE_MOCKS, the API request may be replaced by a
 * call to the corresponding mock JSON file rather than the API.
 *
 * @param {string} apiUrl The URL of the API endpoint we are making the request to
 * @param {function} fetchDataPending Function call returns the pending action object
 * @param {function} fetchDataSuccess Function call returns the success action object
 * @param {function} fetchDataError Function call returns the error action object
 * @returns {function}
 */

function fetchApi(apiUrl, fetchDataPending, fetchDataSuccess, fetchDataError) {
  const finalApiUrl = process.env.REACT_APP_USE_MOCKS === '0'
    ? formatApiUrl(apiUrl)
    : getMockFromApiUrl(apiUrl);


  return dispatch => {
    dispatch(fetchDataPending());
    fetch(finalApiUrl)
      .then(res => res.json())
      .then(res => {
        if (res.error) {
          throw(res.error);
        }
        dispatch(fetchDataSuccess(res));
        return res;
      })
      .catch(error => {
        dispatch(fetchDataError(error));
      })
  }
}

export default fetchApi;

/**
 * @function formatApiUrl
 *
 * Formats the API string to use the language param if needed. Checks the react
 * root element for a boolean (converted to string number)  to determine if the
 * site is multi-language. If so, we prepend the language attribute from the
 * react root to the provided API string, otherwise return the original string.
 *
 * @param {string} apiUrl The unformatted API url
 * @returns {string} The formatted or original API url
 */
function formatApiUrl(apiUrl) {
  const reactRoot = document.getElementById('nppe2-feeding-calc-react-app');

  const apiEndpoint = reactRoot.dataset.multiLanguage
    ? `${reactRoot.dataset.language}${apiUrl}`
    : apiUrl;

  return reactRoot.dataset.base + "/" + apiEndpoint

  /*
  return process.env.REACT_APP_API_URL !== '0'
    ? process.env.REACT_APP_API_URL + apiEndpoint
    : apiEndpoint;
  */
}

/**
 * @function getMockFromApiUrl
 *
 * Return the mock API path from the api URL
 *
 * @param {string} apiUrl
 * @returns {string} The mock API path
 */
function getMockFromApiUrl(apiUrl) {
  const cleanPath = apiUrl.split('?');
  const mockPaths = cleanPath[0].split('/fc_api/');

  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return `/mocks${mockPaths[0]}/${mockPaths[1]}.json`;
  } else {
    return `/modules/custom/nppe2_feeding_calc/app/public/mocks${mockPaths[0]}/${mockPaths[1]}.json`;
  }

}
